export default __webpack_public_path__ + "static/media/portrait_small.b9b5aecc.png";